module.exports = __webpack_public_path__ + "img/914145316.28829dd1.jpg";